import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import StyledImage from "./styled-image"
import Cta from "./cta"
import Carousel from "./carousel"

export default function HotelRooms({ props }) {
  const { heading, content } = props
  const data = useStaticQuery(graphql`
    {
      allWpHotel(sort: {menuOrder: ASC}) {
        nodes {
          title
          uri
          excerpt
          featuredImage {
            node {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 1444)
                }
              } 
            }
          }
          hotelRoom {
            accessibilityOptions
            beds
            size
          }
        }
      }
    }
  `)
  const hotelRooms = data?.allWpHotel.nodes
  const carouselSettingsOverrides = {
    slidesToShow: 1,
    slidesToScroll: 1,
    className: `slick-arrows-centered slick-arrows-wide -mx-[1px]`,
  }

  return (
    <section className="bg-banner-gradient/10 py-12">
      <div className="container" id="hotel-rooms">
        <div className="max-w-4xl mx-auto md:text-center mb-10">
          {heading ? <h2 className="mb-2">{heading}</h2> : null}
          {content ? <div className="parsed-content" dangerouslySetInnerHTML={{ __html: content }} /> : null}
        </div>
        {hotelRooms ?
          <>
            <div className="md:hidden mb-6 px-2">
              <Carousel settingsOverrides={carouselSettingsOverrides}>
                {hotelRooms.map((hotelRoom, index) => {
                  return (
                    <HotelRoomCard props={hotelRoom} key={index} />
                  )
                })
                }
              </Carousel>
            </div>

            <ul className={`hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 lg:gap-10 2xl:gap-16 mb-10`}>
              {hotelRooms.map((hotelRoom, index) => {
                return (
                  <li key={index}>
                    <HotelRoomCard props={hotelRoom} />
                  </li>
                )
              })
              }
            </ul>
          </> : null}
      </div>
    </section>
  )
}
const HotelRoomCard = ({ props }) => {
  const { title, uri, excerpt, featuredImage, hotelRoom } = props
  const { accessibilityOptions, beds, size } = hotelRoom
  const image = featuredImage?.node

  return (
    <div className={`mx-auto md:mx-0 max-w-xs sm:max-w-sm h-full flex gap-4 flex-col justify-between md:max-w-none bg-white sm:shadow-spread shadow-spread-xs pt-4 pb-6 px-5 relative rounded`}>
      <div className={`grid gap-2`}>
        {title ? <h3 className=''>
          <Link to={uri} className="text-body">
            {title}
          </Link>
        </h3> : null}
        {excerpt && (
          <div className="parsed-content line-clamp-3 text-wire">
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt,
              }}
            />
          </div>
        )}
        {accessibilityOptions ? <p className="italic text-wire">Accessible rooms available.</p> : null}
        <div className="flex flex-wrap divide-x divide-slate/50 text-slate -mx-4">
          {size ? <div className="px-4"> {size} </div> : null}
          {beds ? <div className="px-4"> {beds} </div> : null}
        </div>
      </div>
      <div>
        {image ? (
          <Link to={uri} className="block mb-4">
            <StyledImage
              image={image}
              objectFit="cover"
              className={`w-full aspect-video`} />
          </Link>
        ) : null}

        <Cta to={uri} className="btn btn-ruby btn-sm">
          {title.includes("Suite") ? "View Suite Info" : "View Room Info"}
        </Cta>
      </div>
    </div>

  )
}
